import { getStockRule } from '../../services/api/stockRule.api';
import { GET_STOCK_RULE_LIST_REQUEST, GET_STOCK_RULE_LIST_SUCCESS, GET_STOCK_RULE_LIST_FAILURE } from '../types';
import { transformStockRuleDetail } from '../../transforms/allocation';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockRuleDetail({}),
	},

	getters: {
		getForm: (state) => {
			const getCategorySkuKeys = (data) => {
				const isSetCategory = data.isCategoryConfig;
				return {
					categoryIds: data.categoryIds,
					isCategoryAll: !!(isSetCategory && !data.categoryIds.length),

					isSkuAll: !!(!isSetCategory && !data.products.length),
					skuIds: data.products.map((item) => item.sku),
					skuCodes: data.products.map((item) => item.sku),

					excludeSkuIds: data.itecSkuExclusions.map((item) => item.sku),
					excludeSkuCodes: data.itecSkuExclusions.map((item) => item.sku),
				};
			};

			return {
				name: state.data.name,
				priority: Number(state.data.priority || null),
				status: Boolean(state.data.isActive),
				ratio: Number(state.data.onlineRatio || null),
				minQty: Number(state.data.minimum || null),

				branches: state.data.branches,
				branchIds: state.data.branches.map((item) => item.id),
				isBranchAll: !state.data.branches.length,
				branchItecIds: state.data.branches.map((item) => item.itecBranchId),

				...getCategorySkuKeys(state.data),
			};
		},
	},

	mutations: {
		[GET_STOCK_RULE_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_STOCK_RULE_LIST_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformStockRuleDetail(data);
		},
		[GET_STOCK_RULE_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getStockRule({ commit }, id) {
			try {
				commit(GET_STOCK_RULE_LIST_REQUEST);
				const { data } = await getStockRule(id);
				commit(GET_STOCK_RULE_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_STOCK_RULE_LIST_FAILURE, error);
			}
		},
	},
};
